import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Get all agent IDs that belong to a team leader's team
 * @param {string} teamLeaderCode - The team leader's agent_id
 * @returns {Promise<string[]>} Array of agent_ids in the team
 */
export async function getTeamMemberIds(teamLeaderCode) {
  try {
    const agentsRef = collection(db, 'plsss_agents');
    const q = query(
      agentsRef,
      where('apps.agents.teamLeader', '==', teamLeaderCode),
      where('status', '==', 'Active'),
      where('category', '==', 'PLSSS')
    );
    
    const snapshot = await getDocs(q);
    const memberIds = snapshot.docs.map(doc => doc.data().agent_id);
    
    return memberIds;
  } catch (error) {
    console.error('Error fetching team member IDs:', error);
    return [];
  }
}

/**
 * Get detailed team member information
 * @param {string} teamLeaderCode - The team leader's agent_id
 * @returns {Promise<Array>} Array of team member objects
 */
export async function getTeamMembers(teamLeaderCode) {
  try {
    const agentsRef = collection(db, 'plsss_agents');
    const q = query(
      agentsRef,
      where('apps.agents.teamLeader', '==', teamLeaderCode),
      where('status', '==', 'Active'),
      where('category', '==', 'PLSSS')
    );
    
    const snapshot = await getDocs(q);
    const members = snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        agent_id: data.agent_id,
        full_agent_id: doc.id, // Use document ID for full agent ID
        name: data.name,
        email: data.email,
        role: data.apps?.agents?.role || data.role || 'user',
        status: data.status
      };
    });
    
    return members;
  } catch (error) {
    console.error('Error fetching team members:', error);
    return [];
  }
}
